import { useContext } from "react"
import { ListarProdutosContext } from "./ListarProdutosContext"

export function useListarProdutosContext() {
    return useContext(ListarProdutosContext)
}
